<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// App 根组件
</script>

<style lang="scss">
.app-container {
  min-height: 100vh;
  background: var(--bg-color);
}
</style>
